import { addRoute } from "../shared/router.js";
import musicPlayer from "./page.vue";

addRoute("/music-player", musicPlayer);
